import React, { memo } from 'react';
import FormikWrapper from '../FormikWrapper';
import type { InputFieldFactoryProps } from '../Factory/InputFieldFactory';
import type { useFormikContext } from 'formik';
import InternalTable from './InternalTable';

export type TableProps = Pick<InputFieldFactoryProps, 'className' | 'field' | 'hideErrorText'> & {
  isEditing?: boolean;
};

const Table = (props: TableProps) => {
  return (
    <FormikWrapper>
      {(formik: ReturnType<typeof useFormikContext>) => <InternalTable formik={formik} {...props} />}
    </FormikWrapper>
  );
};

export default memo(Table);
